import React from "react";
import { LocaleUtil, StringUtil } from "@eres/core";
import { BCSReClassification } from "@my-dld/utils/TabuServices";
import Strings from "@my-dld/assets/strings";
import { extractPropInfo } from "../MyDLD/PropertyDetails";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import BaseTabuRequestForm, { BaseTabuRequestProps } from "./BaseTabuRequestForm";
import { submitBCSValuation } from "@10x/tabu-mobile-api/dist/requests/api";
import { TabuUtils } from "@10x/tabu-mobile-api";
import TextInputField from "@my-dld/components/Form/TextInputField";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { BCSRequest, TabuProcedure } from "@10x/tabu-mobile-api/dist/requests/entity";
import { getEmail, getEmiratesID, getParticipantID } from "@10x/sso";
import { Redirect } from "react-router";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import PageTitle from "@my-dld/components/PageTitle";
import PageContent from "@my-dld/components/PageContent";
import { phoneNumber, toMobileX } from "../MyDLD/MyProfile";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { FixedMobileInput } from "@my-dld/components/FixedEidInput";
import { checkNonEmpty, ErrorContainerStateProvider } from "@my-dld/components/Form/FormField";
import { ErrorContainer } from "@eres/forms";
import { REQ_SOURCE_DLD_WEB } from "@eres/rtregistrationapi/entities";
import { TabuPropertyType } from "@my-dld/utils/PropertyUtils";
import Popup from "@my-dld/components/Popup/Popup";
import BCSTerms from "@my-dld/assets/strings/bcs_terms";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { TabuRequestContext } from "@my-dld/contexts/TabuRequestContext";

interface State {
	mobile?: string;
	email?: string;
	notes?: string;
	property?: AssetCard;
	errorContainer: ErrorContainer;
}

class BcsReClassificationFrom extends BaseTabuRequestForm<BaseTabuRequestProps, State> {
	static contextType = TabuRequestContext;
	context!: React.ContextType<typeof TabuRequestContext>;

	constructor( props: BaseTabuRequestProps ) {
		super( props );
		let mobile = phoneNumber();
		if ( mobile && !StringUtil.isEmptyStringOrNull( mobile ) ) {
			mobile = toMobileX( mobile );
		}
		let email = getEmail();
		this.state = {
			mobile: mobile,
			email: email,
			errorContainer: {},
		};
	}

	componentDidMount() {
		this.setState( {
			property: this.context.property,
		} );
	}

	render() {
		const property = this.context.property;
		if ( property == null ) {
			return <Redirect to={ "/mydld" }/>;
		}
		const title = LocaleUtil.getLocalValue( BCSReClassification.Name );
		const { val, lbl } = extractPropInfo( property );
		return <PageContent
			title={ `${ title } - ${ lbl } : ${ val }` }
			hideQLinks={ true }>
			<PageTitle title={ title } paths={ [ DashboardBCItem ] }/>
			<div className="card">
				<div className="card-header">
					<span>{ Strings.contact_information }</span>
					<span className={ "card-header-sub" }>{ Strings.bcs_contact_information_detail }</span>
				</div>
				<div className="card-body">
					<div className="mandatory-field-info">
						<small>{ Strings.mandatory_fields_note }</small>
					</div>
					<div className="row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
							<FixedMobileInput
								id={ "mobile" }
								holder={ this }
								required={ true }
								errorProvider={ ErrorContainerStateProvider }
								label={ Strings.mobile_number }
								containerClassName={ "form-group field-style" }
								inputClassName={ "form-control" }/>
						</div>
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
							<TextInputField
								id={ "email" }
								holder={ this }
								required={ true }
								errorProvider={ ErrorContainerStateProvider }
								label={ Strings.email }
								containerClassName={ "form-group field-style" }
								inputClassName={ "form-control" }/>
						</div>
					</div>
					<div className="row">
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
							<TextInputField
								id={ "notes" }
								holder={ this }
								label={ Strings.notes }
								errorProvider={ ErrorContainerStateProvider }
								maxLength={ 256 }
								customInput={ <textarea rows={ 4 }/> }
								containerClassName={ "form-group field-style" }
								inputClassName={ "form-control" }/>
						</div>
					</div>
					{/*<div className="row bcs-terms">
                        <TermsAndConditions />
                    </div>*/ }
				</div>


			</div>
			<div className="row">
				<div className="col-md-12 mt-3">
					<button
						className="btn btn_1 btn_style1" type="submit" id="btnContinue"
						onClick={ this.onContinue }>{ Strings.continue }</button>
					<a className="ms-3" onClick={ this.onReset }>{ Strings.reset }</a>
				</div>
			</div>
		</PageContent>;
	}

	getErrors = () => {
		return Object.values( this.state.errorContainer ).reduce( ( previousValue, currentValue ) => previousValue + "\n" + currentValue, "" ).trim();
	};
	private onContinue = () => {
		if ( this.validateForm() ) {
			this.submitRequest();
		} else {
			this.setState( {}, () => {
				let error = this.getErrors();
				if ( !error ) error = Strings.mandatory_fields_note;
				showErrorMessage( error );
			} );
		}
	};

	private onReset = () => {
		let mobile = phoneNumber();
		if ( mobile && !StringUtil.isEmptyStringOrNull( mobile ) ) {
			mobile = toMobileX( mobile );
		}
		let email = getEmail();
		this.setState( {
			mobile, email,
		} );
	};

	private validateForm() {
		const state = this.state;
		let { mobile, email, notes } = state;
		mobile = toMobileX( mobile + "" );
		let isValid = true;
		let errorViews: ErrorContainer = {};
		isValid = checkNonEmpty( state, "mobile", errorViews ) && isValid;
		isValid = checkNonEmpty( state, "email", errorViews ) && isValid;
		if ( mobile.length < 12 ) {
			isValid = false;
			errorViews[ "mobile" ] = Strings.invalid_mobile;
		}
		if ( !StringUtil.isEmailAddress( email + "" ) ) {
			isValid = false;
			errorViews[ "email" ] = Strings.invalid_email;
		}
		this.setState( { errorContainer: errorViews } );
		return isValid;
	}

	private submitRequest() {
		showLoading();
		const state = this.state;
		let { email, mobile, notes, property } = state;

		const req: BCSRequest = {
			ProcedureId: BCSReClassification.ID,
			PropertyWithTypeIds: [ {
				PropertyId: property!.propertyId,
				PropertyTypeId: property!.propertyTypeId,
			} ],
			ParticipantId: "" + getParticipantID(),
			AdditionalData: [ {
				Key: "ParticipantId",
				Value: getParticipantID()!.toString(),
			},
				{
					Key: "RequestSource",
					Value: REQ_SOURCE_DLD_WEB,
				}
			],
			PropertySource: "Tabu",
			RequestSource: "DLDWebsite",
			LandPropertyId: property!.landPropertyId!,
			BuildingPropertyIds: [],
			EmirtesId: getEmiratesID() ?? "",
			OwnerEmail: email ?? "",
			ContactEmail: email ?? "",
			ContactMobile: mobile ?? "",
			Notes: notes ?? "",

		};
		if ( property!.propertyTypeId !== TabuPropertyType.LAND && property!.buildingPropertyId )
			req.BuildingPropertyIds = [ property!.buildingPropertyId ];
		trackEventWithData( "TabuProcedure", "TrySubmit", req );
		submitBCSValuation( req ).then( TabuUtils.validateResponse ).then( ( resp: TabuProcedure ) => {
			hideLoading();
			trackEventWithData( "TabuProcedure", "SubmitSuccess", {
				number: resp.ProcedureNumber,
				year: resp.ProcedureYear, ...req
			} );
			this.navigateToVoucher( this.props, resp );
		} ).catch( ( reason ) => {
			hideLoading();
			showErrorMessage( reason.toString() );
			trackEventWithData( "TabuProcedure", "SubmitFail", { reason: reason.toString(), ...req } );
		} );
	}
}

function TermsAndConditions() {
	const popUp = React.useRef<Popup>( null );
	const showTerms = () => {
		popUp.current?.show();
	};
	const hideTerms = () => {
		popUp.current?.dissmiss();
	};

	return <div className="d-flex pb-2">
		<button className="btn btn-link ms-1" onClick={ showTerms }>{ Strings.terms_and_conditions }</button>
		<Popup
			ref={ popUp }
			id={ "BCSTermsPopup" }
			modalMainContainer={ "modal fade" }
			modalSubContainer={ "modal-dialog modal-dialog-centered modal-lg" }
			title={ Strings.terms_and_conditions }
			showIcon={ false }
			modalBodyContainer={ "p-3" }>
			<div className="modal-body p-3">
				<ol className="list-unstyled terms-and-condition-list">
					{ BCSTerms && BCSTerms.map( ( term: LocaleValue, index: number ) => {
						return <React.Fragment key={ "tc_term_" + index }>
							<li>{ LocaleUtil.getLocalValue( term ) }</li>
						</React.Fragment>;
					} ) }
				</ol>
			</div>
			<div className="modal-footer d-flex justify-content-center">
				<button type="button" className="btn btn-grey" onClick={ hideTerms }>{ Strings.close }</button>
			</div>
		</Popup>
	</div>;
}

export default BcsReClassificationFrom;
